// extracted by extract-css-chunks-webpack-plugin
module.exports = {"list_menu":"list_menu-3x_HQaXc","morehNew":"morehNew-2uOEBkyd","more":"more-9r6PZFoG"};